module.exports = __webpack_public_path__ + "img/DanSurgery.2b4cfbea.jpg";